(ns frontend.test.search-popover
  (:require
   [frontend.routing :as routing]
   [frontend.ui.page.lp-report-editor.step-2-data-gathering.modal.upload-modal :as upload-modal]
   [reagent.core :as r]
   [common.entity :as entity]
   [ui.components.radix-ui.popover.view :as popover]
   [re-frame.core :as rf]))

(defn view
  []
  (let []
    [:div.p-5
     "Todo"]))

(defmethod routing/render-view :test/search-popover
  [{:keys [route-params]}]
  [view])
